import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";

export const createEmailTemplate = {
  name: "createEmailTemplate" as const,
  input: emailTemplateSchema.omit({ _id: true }),
  output: emailTemplateSchema,
};
